import React from 'react'
import { OpportunityInvestmentProjectionInputProps } from '../../lib/types'
import { displayTicketSize } from '../../lib/utils/helpers'
import { toCurrencyLabel } from './opportunity-detail.utils'

const OpportunityInvestmentProjectionInput = ({
  currencyCode,
  ticketSize,
  sliderMin,
  sliderMax,
  sliderStep,
  startingAmount,
  onAmountChange,
}: OpportunityInvestmentProjectionInputProps) => (
  <div className='opportunity-investment-projection-input-card'>
    <label className='opportunity-investment-projection-input-label' htmlFor='starting-amount'>
      Starting amount
    </label>
    <div className='opportunity-investment-projection-input-value'>
      {toCurrencyLabel(startingAmount, currencyCode)}
    </div>
    <input
      id='starting-amount'
      type='range'
      min={sliderMin}
      max={sliderMax}
      step={sliderStep}
      value={startingAmount}
      onChange={onAmountChange}
      className='opportunity-investment-projection-slider'
    />
    <div className='opportunity-investment-projection-slider-scale'>
      <span>{toCurrencyLabel(sliderMin, currencyCode)}</span>
      <span>{toCurrencyLabel(sliderMax, currencyCode)}</span>
    </div>
    <p className='opportunity-investment-projection-input-helper'>
      Minimum ticket size: {displayTicketSize(ticketSize, currencyCode) || '$0'}
    </p>
  </div>
)

export default OpportunityInvestmentProjectionInput
